/* ===== Néovital — shared behaviors (idempotent) ===== */
(function(){
  if (window.__nvtInit) { window.__nvtBoot && window.__nvtBoot(); return; }
  window.__nvtInit = true;

  // Smooth-scroll any CTA to the buy-box + focus the variant picker / qty
  function scrollToBuybox(){
    var t = document.getElementById('nvt-buybox') ||
            document.querySelector('.lv-product-main, [id^="shopify-section"] variant-selects, .product-form');
    if(!t) return;
    var header = document.querySelector('.header, header, [class*="header-group"]');
    var off = (header && header.getBoundingClientRect().height) || 80;
    var y = t.getBoundingClientRect().top + window.pageYOffset - Math.min(off,100) - 10;
    window.scrollTo({top:y, behavior:'smooth'});
    var picker = document.querySelector('.lv-product-main variant-selects input, .lv-product-main select, #nvt-offer input');
    if(picker){ setTimeout(function(){ try{picker.focus({preventScroll:true});}catch(e){} }, 650); }
  }
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-nvt-scroll]');
    if(b){ e.preventDefault(); scrollToBuybox(); }
  });
  window.nvtScrollToBuybox = scrollToBuybox;

  // Before/After slider
  function initSlider(root){
    if(root.__done) return; root.__done = true;
    var top = root.querySelector('.nvt-ba-top');
    var handle = root.querySelector('.nvt-ba-handle');
    var dragging=false;
    function setp(p){ p=Math.max(0,Math.min(100,p)); if(top) top.style.clipPath='inset(0 '+(100-p)+'% 0 0)'; handle.style.left=p+'%'; }
    function move(clientX){ var r=root.getBoundingClientRect(); setp((clientX-r.left)/r.width*100); }
    root.addEventListener('mousedown',function(e){dragging=true;move(e.clientX);});
    window.addEventListener('mousemove',function(e){if(dragging)move(e.clientX);});
    window.addEventListener('mouseup',function(){dragging=false;});
    root.addEventListener('touchstart',function(e){dragging=true;move(e.touches[0].clientX);},{passive:true});
    root.addEventListener('touchmove',function(e){if(dragging)move(e.touches[0].clientX);},{passive:true});
    root.addEventListener('touchend',function(){dragging=false;});
    setp(50);
  }

  // Simple track carousel with dots + arrows (snap)
  function initCarousel(root){
    if(root.__done) return; root.__done = true;
    var track = root.querySelector('.nvt-car-track');
    var dotsBox = root.querySelector('.nvt-car-dots');
    var prev = root.querySelector('.nvt-car-prev');
    var next = root.querySelector('.nvt-car-next');
    var cards = track ? track.children : [];
    if(!track || !cards.length) return;
    function step(){ return cards[0].getBoundingClientRect().width + 18; }
    if(dotsBox){
      dotsBox.innerHTML='';
      for(var i=0;i<cards.length;i++){
        var d=document.createElement('button'); d.className='nvt-car-dot'; d.type='button';
        d.setAttribute('aria-label','slide '+(i+1));
        (function(idx){ d.addEventListener('click',function(){ track.scrollTo({left:idx*step(),behavior:'smooth'}); }); })(i);
        dotsBox.appendChild(d);
      }
    }
    function sync(){
      var idx=Math.round(track.scrollLeft/step());
      if(dotsBox){ Array.prototype.forEach.call(dotsBox.children,function(dot,i){ dot.classList.toggle('on',i===idx); }); }
    }
    track.addEventListener('scroll',sync,{passive:true});
    if(prev) prev.addEventListener('click',function(){ track.scrollBy({left:-step(),behavior:'smooth'}); });
    if(next) next.addEventListener('click',function(){ track.scrollBy({left:step(),behavior:'smooth'}); });
    sync();
  }

  function boot(){
    document.querySelectorAll('.nvt-ba').forEach(initSlider);
    document.querySelectorAll('.nvt-car').forEach(initCarousel);
  }
  window.__nvtBoot = boot;
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();
  // re-run on Shopify section load (theme editor)
  document.addEventListener('shopify:section:load',boot);
})();
